import apiUrl from '../../../constants'
import { nudgeBus } from '@/utils/nudgeBus'
import user_tracker from '../../../usertracker'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import utils from '../../../utils/validateScanner.js'
import IRTException from '../../../utils/IRTException.js';
import {
	Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import moment from 'moment';
import { showMandatoryWeighingSnackbar, handleMandatoryWeighingHardBlock, isMandatoryWeighingSoftBlock, shouldShowMandatoryWeighingResultField } from '../../../utils/mandatoryWeighingResponse.js';
export default {
	name: 'bag-out-shipment',
	mixins: [utils,IRTException],
	components: {
		Paginate,
		VueElementLoading
	},
	props: [],
	data() {
		return {
			pageCount: 0,
			pageNo: 0,
			bagno: '',
			SecurityPouch: '',
			totalRecords: 0,
			shipmentid: '',
			shipmentForColor:'',
			shipmentidwithsecuritypatch: '',
			shipmentidwithoutsecuritypatch: '',
			isLoading: false,
			listBagSearchdata: [],
			BagOutShipmentData: [],
			showBagData: false,
			AutoBagOut: false,
			showshipmentList: false,
			disableAutoBagOutBtn: 0,
			disableTallyBtn: 0,
			checkAutoBagOutShipment: '',
			checkTallyBagShipment: '',
			hubId: '',
			useremail: '',
			hubName: '',
			BagOutShipmentlist: [],
			mandatoryWeighingSoftBlock: false,
			ShipmentDetails: [],
			userdetail: '',
			token: '',
			invalidTokenModal: false,
			invalidtokenmsg: '',
			timeoutHandler: 0,
			inputString:'',
			manualInput:false,
			userData:[],
			dtoFlag :false,
			centerType:'',
			modalShow:false,
			shippingIdList:[],
			shortagemarkflag : false,
			isLinearFlowEnabledShipmentFlag : false,
			ConfirmShipmentShortage: false,
			shortageShipmentDetails: {
				shippingid: "",
				shipmentstatus: "",
				status: ""
			},
			isLoadingSearch:false,
			showTable:false,
			ConfirmBagOutUser : false,
			lastBagOutUser : '',
			mot : '',
			ReturnMessagePrompt : '',
			isLspBag : false,
			Weighingrequired:null,
			flyerID:'',
			isDTOFlyer: false
		}
	},
	computed: {
		showBagOutShipmentDetailPanel() {
			if (!this.BagOutShipmentData || !Object.keys(this.BagOutShipmentData).length) {
				return false;
			}
			if (this.mandatoryWeighingSoftBlock) {
				return this.displayMandatoryWeighingField(this.BagOutShipmentData.ShippingID)
					|| this.displayMandatoryWeighingField(this.BagOutShipmentData.PendingCount)
					|| this.displayMandatoryWeighingField(this.BagOutShipmentData.scannedShipmentCount);
			}
			return !!(this.BagOutShipmentData.sortCode || this.BagOutShipmentData.ServiceType);
		}
	},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var userTokenEncrypt = window.localStorage.getItem('userToken')
		var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
		var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
		this.token = JSON.parse(userToken)
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userData=userdetail
		this.userdetail = userdetail[0]
		this.useremail = userdetail[0].email;
		this.userid = parseInt(userdetail[0].userid, 10); 
		this.hubId = userdetail[0].HubId[0];
		this.getHubName(userdetail[0].HubId);
		// user_tracker.checkUserIP(userdetail[0], "BagOutShipment",this.$route.path);

		this.hubForManualRestriction();

		// Get List of IRT Exception Type
		this.getExceptionTypes();
	},
	methods: {
		displayMandatoryWeighingField(value) {
			return shouldShowMandatoryWeighingResultField(this.mandatoryWeighingSoftBlock, value);
		},
		checkBarcode(e){
			if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler)
      this.inputString += String.fromCharCode(e.keyCode)
    	}
			this.timeoutHandler = setTimeout(() => {
		 		if (this.inputString.length <= 3) {
			 		this.manualInput = true
			 		this.inputString = ''
		 		}else{
			 		this.manualInput = false
			 		this.inputString = ''
		 		}
	 		}, 10)
 		},
		getHubName(hubid) {
			this.input = {
				hubids: hubid
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.hubName = result.data.ResponseData[0].HubName;
						this.centerType = result.data.ResponseData[0].CenterType;
					} else {
						this.hubName = '';
					}
				}, error => {
					console.error(error)
				})
		},
		logout(e) {
			localStorage.removeItem('permissiondata')
			localStorage.removeItem('userdetail')
			localStorage.removeItem('userToken')
			localStorage.removeItem('isLoggedIn')
			localStorage.removeItem('loginDate')
			this.$router.push('/login')
			e.preventDefault()
		},
		closeinvalidTokenModal() {
			this.invalidTokenModal = false
			this.invalidtokenmsg = ''
		},
		searchBag() {
			this.BagOutShipmentlist = []
			this.listBagSearchdata = []
			this.BagOutShipmentData = [];
			this.showshipmentList = false
			this.isDTOFlyer = false;
			if (this.bagno == '') {
				return false;
			} else {
				this.isLoading = true
				this.input = ({});
				axios({
						method: 'GET',
						'url': apiUrl.api_url_hubops + 'getBagDetails?BagNo=' + this.bagno.trim() + '&HubID=' + this.hubId + '&LastModifiedBy=' + this.useremail,
						'data': this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
							'requestfrom': "WEB",
							'token': this.token
						}
					})
					.then(result => {
						if (result.data.ResultCode == 100) {
							if (result.data.lossCategorization && Object.keys(result.data.lossCategorization).length != 0) {
								this.colorCodeBag = result.data.lossCategorization.colorCode;
								this.colorIconBag = result.data.lossCategorization.icon;
							}
							this.invalidTokenModal = false
							this.AutoBagOut = false
							this.showBagData = true
							this.disableAutoBagOutBtn = 0
							this.disableTallyBtn = 0
							this.checkAutoBagOutShipment = ''
							this.checkTallyBagShipment = ''
							this.listBagSearchdata = result.data.ResponseData;
							this.shortagemarkflag = result.data.ismarkshortagebag;
							this.isLinearFlowEnabledShipmentFlag = result.data.isLinearFlowEnabledShipment;
							this.isLspBag = result.data.isLspBag;
							if(this.listBagSearchdata[0].bagtype == "DTOBag"){
                                    this.dtoFlag = true;
							}	
							if (result.data.mot === 'AIR' && this.mot == '') {
								this.addBlur();
								this.$toast.info('Mode: AIR', {
								timeout: 10000,
								position: 'top-right',
								className: 'blue-toast',
								onClose: this.removeBlur,  
							  });
						  	}
							//this.$alertify.success(result.data.ReturnMessage)
						} else if (result.data.ResultCode == 112) {
							if (result.data.lossCategorization && Object.keys(result.data.lossCategorization).length != 0) {
								this.colorCodeBag = result.data.lossCategorization.colorCode;
								this.colorIconBag = result.data.lossCategorization.icon;
							}
							this.invalidTokenModal = false
							this.AutoBagOut = true
							this.disableAutoBagOutBtn = 0
							this.disableTallyBtn = 0
							this.showBagData = true
							this.totalRecords = 0
							this.ShipmentDetails = []
							this.listBagSearchdata = result.data.ResponseData;
							this.shortagemarkflag = result.data.ismarkshortagebag;
							this.isLinearFlowEnabledShipmentFlag = result.data.isLinearFlowEnabledShipment;
							this.isLspBag = result.data.isLspBag;
							if(this.listBagSearchdata[0].bagtype == "DTOBag"){
                                    this.dtoFlag = true;
							}		
							if (result.data.mot === 'AIR' && this.mot == '') {
								this.addBlur();
								this.$toast.info('Mode: AIR', {
								timeout: 10000,
								position: 'top-right',
								className: 'blue-toast',
								onClose: this.removeBlur,  
							  });
						  	}
							//this.$alertify.success(result.data.ReturnMessage)
						} else if (result.data.ResultCode == 120) {
							this.ConfirmBagOutUser = true;
							this.lastBagOutUser = result.data.LastModifiedBy;
							this.ReturnMessagePrompt = result.data.ReturnMessage;
						} else if (result.data.ResultCode == 401) {
							this.invalidTokenModal = true
							this.invalidtokenmsg = result.data.ReturnMessage
							this.$alertify.error(result.data.ReturnMessage)
						} else {

							// IRT Exception Error & Tracking No
							if(result.data.Trackingno) this.openIRTExceptionModal(this.bagno, result.data.ReturnMessage, result.data.Trackingno);

							this.invalidTokenModal = false
							this.disableAutoBagOutBtn = 1
							this.disableTallyBtn = 0
							this.AutoBagOut = false
							this.showBagData = false
							this.totalRecords = 0
							this.ShipmentDetails = []
							this.listBagSearchdata = []
							this.$alertify.error(result.data.ReturnMessage)
						}
						this.isLoading = false
					}, error => {
						this.isLoading = false
						console.error(error)
					})
			}
		},
		CloseBagConfirmation() {
			this.ConfirmBagOutUser = false;
			this.changeBagUser('Cancel');
		},
		changeBagUser(ActionType) {
			this.isLoadingSearch = true;
			if(this.email == '') {
				return false;
			} else {
				this.input = ({
					BagNo: this.bagno.trim(),
					HubID: this.hubId.toString(),
					LastModifiedBy: this.lastBagOutUser,
					UpdatedBy: this.useremail,
					Source : 'WEB',
					ActionType: ActionType	
				});
				axios({
					method : 'POST',
					'url' : apiUrl.api_url_hubops + 'changeBagUserInfoRedis',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
						'requestfrom': "WEB",
						'token': this.token
					}
				})
				.then(result => {
					if(result.data.ResultCode == 100) {
						this.ConfirmBagOutUser = false;
						this.isLoadingSearch = false;
						this.lastBagOutUser = '';
						this.$alertify.success(result.data.ReturnMessage);
						if(ActionType == 'Confirm') {
							this.searchBag();
						}
					} else {
						this.ConfirmBagOutUser = false;
						this.isLoadingSearch = false;
						this.lastBagOutUser = '';
						this.$alertify.error(result.data.ReturnMessage)
					}
				}, error => {
					this.isLoadingSearch = false
					console.error(error)
				})
			}
		},
		addBlur() {
			document.body.classList.add('blurred');
		  },
		  removeBlur() {
			document.body.classList.remove('blurred');
		  },

		BagOutScanSipment() {
			if (this.shipmentidwithoutsecuritypatch == '') {
				// this.$alertify.error('The Shipment ID field is required.')
				return false;
			} else {
				this.shipmentForColor = '';
				var isMultipleshipment = /[,]/.test(this.shipmentidwithoutsecuritypatch)
				this.mandatoryWeighingSoftBlock = false;
				this.isLoading = true
				if(isMultipleshipment==true){
					this.BagOutShipmentlist = []
					this.input = ({
						ParentBagNo: this.bagno,
						ShippingID: this.shipmentidwithoutsecuritypatch.split(','),
						LastModifiedBy: this.useremail,
						HubID: this.hubId.toString(),
						Status: 'BagOut',
						ProcessLocationName: this.hubName,
						StatusMarkedFrom: 'web'
					});
					if (this.userid) {
						this.input.userId = this.userid;
					  }
					axios({
							method: 'POST',
							'url': apiUrl.api_url_hubops + 'bulkBagoutProcess ',
							'data': this.input,
							headers: {
								'authorization': 'authkey xB84JJ89Hd25',
								'requestfrom': "WEB",
								'token': this.token
							}
						})
						.then(result => {
							if (result.data.ResultCode == 100) {
								this.shipmentidwithoutsecuritypatch = ''
								this.manualInput = false
								this.$validator.reset()
								this.checkTallyBagShipment = ''
								this.disableTallyBtn = 0
								this.$alertify.success(result.data.ReturnMessage)
							
								
							} else {
								this.$alertify.error(result.data.ReturnMessage);
							}
							this.isLoading = false
						}, error => {
							this.isLoading = false
							console.error(error)
						})
				}
				else{
					this.BagOutShipmentlist = []
					this.mot = '';
					this.BagOutShipmentData = [];
					this.input = ({
						ParentBagNo: this.bagno,
						ShippingID: this.shipmentidwithoutsecuritypatch.trim(),
						LastModifiedBy: this.useremail,
						HubID: this.hubId.toString(),
						Status: 'BagOut',
						ProcessLocationName: this.hubName,
						StatusMarkedFrom: 'WEB',
						isManualEntry: this.manualInput
					});

					if(this.flyerID) this.input.flyerID = this.flyerID;

					if (this.userid) {
						this.input.userId = this.userid;
					  }
					axios({
							method: 'PUT',
							'url': apiUrl.api_url_hubops + 'bagOutProcess',
							'data': this.input,
							headers: {
								'authorization': 'authkey xB84JJ89Hd25',
								'requestfrom': "WEB",
								'token': this.token
							}
						})
						.then(result => {
							this.shipmentForColor = this.shipmentidwithoutsecuritypatch.trim()

							if (handleMandatoryWeighingHardBlock(this, result.data, 'bagOutProcess')) {
								this.isLoading = false;
								return;
							}

							if (result.data.ResultCode == 100 || result.data.ResultCode == 112) {
								showMandatoryWeighingSnackbar(this, result.data);
								this.mandatoryWeighingSoftBlock = isMandatoryWeighingSoftBlock(result.data);
								if(result.data.isReverseWeightCapturedCheck===false){
									this.Weighingrequired= false;
								}
								else if(result.data.isReverseWeightCapturedCheck===true){
									this.Weighingrequired= true;
								}
								else{
									this.Weighingrequired= null;
								}
								
								this.invalidTokenModal = false
								this.shipmentidwithoutsecuritypatch = ''
								this.manualInput = false
								this.$validator.reset()
								this.disableTallyBtn = 0
								this.checkTallyBagShipment = ''
								if (result.data.mot === 'AIR' && this.mot == '') {
									this.mot = result.data.mot;
									this.addBlur();
									this.$toast.info('Mode: AIR', {
									timeout: 10000,
									position: 'top-right',
									className: 'blue-toast', // Custom class for styling
									onClose: this.removeBlur,  // Remove blur when the toast closes
								  });
								}
								if (Number(result.data.PendingCount) != 0) {
									if (this.mandatoryWeighingSoftBlock) {
										if (this.listBagSearchdata && this.listBagSearchdata[0]) {
											this.listBagSearchdata[0].scannedShipmentCount = result.data.scannedShipmentCount;
										}
									} else {
										this.searchBag();
									}
								} else if (this.listBagSearchdata && this.listBagSearchdata[0]) {
									this.listBagSearchdata[0].scannedShipmentCount = result.data.scannedShipmentCount;
								}
								this.BagOutShipmentData = Object.assign({}, result.data.ResponseData || {});
								if (!this.mandatoryWeighingSoftBlock) {
									this.BagOutShipmentData.ServiceType = result.data.ServiceType;
									this.BagOutShipmentData.GroupDetail = result.data.GroupDetail;
									this.BagOutShipmentData.mot = result.data.mot;
									this.BagOutShipmentData.Zone = result.data.Zone;
									this.BagOutShipmentData.Destination = result.data.Destination;
									this.BagOutShipmentData.patnerName = result.data.patnerName;
									this.BagOutShipmentData.entitiyName = result.data.entitiyName;
									if(result.data.sortCode) {
										this.BagOutShipmentData.sortCode = result.data.sortCode;
									}
								}
								if (result.data.PendingCount !== undefined && result.data.PendingCount !== '') {
									this.BagOutShipmentData.PendingCount = result.data.PendingCount;
								}
								if (result.data.scannedShipmentCount !== undefined && result.data.scannedShipmentCount !== '') {
									this.BagOutShipmentData.scannedShipmentCount = result.data.scannedShipmentCount;
								}

								const listRow = {
									ParentBagNo: (result.data.ResponseData && result.data.ResponseData.ParentBagNo) || this.bagno,
									ShippingID: (result.data.ResponseData && result.data.ResponseData.ShippingID)
										|| result.data.shippingId
										|| result.data.ShippingID,
									RouteID: result.data.ResponseData && result.data.ResponseData.RouteID
								};
								if (!this.mandatoryWeighingSoftBlock) {
									listRow.PDD = result.data.PDD;
									listRow.colorcode = result.data.colorcode;
									listRow.SubClusterName = result.data.SubClusterName;
									listRow.DateOfRequest = result.data.DateOfRequest;
									listRow.CustomerRequest = result.data.CustomerRequest;
									listRow.RescheduledShipmentDate = result.data.RescheduledShipmentDate;
									listRow.SubRequest = result.data.SubRequest;
									listRow.RequestType = result.data.RequestType;
									listRow.ShipmentPriority = result.data.lossCategorization && Object.keys(result.data.lossCategorization).length !=0 ? result.data.lossCategorization.shipmentPriority : '';
									listRow.Source = result.data.Source;
								}
								this.BagOutShipmentlist.push(listRow);

								this.flyerID = '';
								this.isDTOFlyer = false;
								this.$alertify.success(result.data.ReturnMessage)
							}else if (result.data.ResultCode == 101) {
								if(result.data.isOverageSuccess === true) {
									this.shipmentidwithoutsecuritypatch = ''
								    this.manualInput = false
									this.searchBag();
								}
								this.$validator.reset()
								this.$alertify.error(result.data.ReturnMessage)
							}
							 else if (result.data.ResultCode == 401) {
								this.invalidTokenModal = true
								this.invalidtokenmsg = result.data.ReturnMessage
								this.$alertify.error(result.data.ReturnMessage)
							} else if (result.data.ResultCode == 107) {
								this.isDTOFlyer = true;
								this.$nextTick(() => {
									this.$refs.flyer.focus();
								});
							} else if (result.data.ResultCode == 108) {
								this.flyerID = '';
								this.isDTOFlyer = false;
								
								this.$nextTick(() => {
									this.$refs.ship.focus();
								});
								
								this.$validator.reset()
								this.invalidTokenModal = false
								this.$alertify.error(result.data.ReturnMessage);
							} else {
								
								this.$validator.reset()
								this.invalidTokenModal = false
								this.$alertify.error(result.data.ReturnMessage);
							}
							
							if (result.data.FlyerPrompt) this.$toast.success(result.data.FlyerPrompt, { timeout: 10000, style: { marginBottom: "70px" }, position: 'bottom-right' });

							if (result.data.nudgeMessage) { nudgeBus.$emit('show-nudge', { message: result.data.nudgeMessage, duration: result.data.nudgeDuration }) }

							if(result.data.lossCategorization && Object.keys(result.data.lossCategorization).length !=0){
								this.showHideCodeIconInput(result.data.lossCategorization.colorCode, result.data.lossCategorization.icon);
							}

							// IRT Exception Error & Tracking No
							if(result.data.Trackingno) this.openIRTExceptionModal(this.shipmentForColor, result.data.ReturnMessage, result.data.Trackingno);

							user_tracker.checkUserIP(this.userData[0], "BagOutShipment",this.$route.path,this.input);
							this.isLoading = false
						}, error => {
							this.isLoading = false
							console.error(error)
						})
				}
			}
		},
		autoBagOutShipment() {
			this.isLoading = true
			this.input = ({
				ParentBagNo: this.bagno,
				LastModifiedBy: this.useremail,
				HubID: this.hubId.toString(),
				ProcessLocationName: this.hubName,
				StatusMarkedFrom: 'WEB',
				isLspBag: this.isLspBag
			});
			if (this.userid) {
				this.input.userId = this.userid;
			  }
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'processAutoBagOutShipment',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
						'requestfrom': "WEB",
						'token': this.token
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.invalidTokenModal = false
						this.shipmentidwithoutsecuritypatch = ''
						this.manualInput = false
						this.checkAutoBagOutShipment = ''
						this.checkTallyBagShipment = ''
						this.disableAutoBagOutBtn = 0,
							this.disableTallyBtn = 0,
							this.$alertify.success(result.data.ReturnMessage)
					} else if (result.data.ResultCode == 401) {
						this.invalidTokenModal = true
						this.invalidtokenmsg = result.data.ReturnMessage
						this.$alertify.error(result.data.ReturnMessage)
					} else {
						this.invalidTokenModal = false
						this.$alertify.error(result.data.ReturnMessage);
					}
					this.isLoading = false
				}, error => {
					this.isLoading = false
					console.error(error)
				})
		},

		tallyShipment() {
			this.isLoading = true
			this.input = ({
				ParentBagNo: this.bagno,
				LastModifiedBy: this.useremail,
				BagType: this.listBagSearchdata[0].bagtype,
				ProcessLocationName: this.hubName,
				ProcessLocation: this.hubId.toString(),
				centerType:this.centerType
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'pushShortageShipmentsToSQS',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
						'requestfrom': "WEB",
						'token': this.token
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.invalidTokenModal = false
						this.disableTallyBtn = 1
						this.modalShow=false;
						this.$alertify.success(result.data.ReturnMessage)
					} else if (result.data.ResultCode == 401) {
						this.invalidTokenModal = true
						this.invalidtokenmsg = result.data.ReturnMessage
						this.$alertify.error(result.data.ReturnMessage)
					} else {
						this.invalidTokenModal = false
						this.$alertify.error(result.data.ReturnMessage);
					}
					this.isLoading = false
				}, error => {
					this.isLoading = false
					console.error(error)
				})
		},

		getShipmentDetails() {
			this.ShipmentDetails = []
			if (this.bagno == '') {
				// this.$alertify.error('The Bag No field is required.')
				return false;
			} else {
				this.isLoading = true
				this.input = ({});
				axios({
						method: 'GET',
						'url': apiUrl.api_url_hubops + 'getBagOutShipmentList?BagNo=' + this.bagno.trim() + '&isLspBag=' + this.isLspBag,
						'data': this.input,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25',
							'requestfrom': "WEB",
							'token': this.token
						}
					})
					.then(result => {
						if (result.data.ResultCode == 100) {
							this.invalidTokenModal = false
							this.ShipmentDetails = result.data.ResponseData;
							this.showshipmentList = true
							this.totalRecords = result.data.ResponseData.length
							for(let i=0; i<this.totalRecords; i++){
								if(result.data.ResponseData[i].PDD){
									let pddDate = new Date(result.data.ResponseData[i].PDD).setHours(0,0,0,0);
				          let currentDate = new Date().setHours(0,0,0,0);
									this.ShipmentDetails[i].pddColor = (pddDate == currentDate) ? "#FFBF00" : (pddDate > currentDate)  ? "#008000" : "#FF0000";
									this.ShipmentDetails[i].pddDate = moment(result.data.ResponseData[i].PDD).format('DD-MM-YYYY');
								}
							}
							// this.$alertify.success(result.data.ReturnMessage)
						} else if (result.data.ResultCode == 401) {
							this.invalidTokenModal = true
							this.invalidtokenmsg = result.data.ReturnMessage
							this.$alertify.error(result.data.ReturnMessage)
						} else {
							this.invalidTokenModal = false
							this.showshipmentList = false
							this.ShipmentDetails = []
							this.totalRecords = 0
							this.$alertify.error(result.data.ReturnMessage)
						}
						this.isLoading = false
					}, error => {
						this.isLoading = false
						console.error(error)
					})
			}
		},
		ConfirmShipmentShortageMark(shippingid) {
			this.ConfirmShipmentShortage = true;
			this.loadShipmentDetails(shippingid);
		},
		CloseConfirmation() {
			this.ConfirmShipmentShortage = false;
		},
		loadShipmentDetails(shippingid) {
			this.isLoadingSearch = true
			this.input = {}
			axios({
					method: 'GET',
					'url': apiUrl.api_url_hubops + 'getShipmentDetailsForShortage?flow=markShortage&ShippingID=' + shippingid,
					headers: {
						'Authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					var response = result.data
					if (response.ResultCode == 100) {
						if (response.ResponseData) {
							this.isLoadingSearch = false;
							this.showTable = true;
							this.shortageShipmentDetails = response.ResponseData;
						}
					} else {
						this.shortageShipmentDetails = {};
						this.isLoadingSearch = false;
						this.showTable = false;
						this.$alertify.error(result.data.ReturnMessage)
					}
					this.isLoading = false
				}, error => {
					console.log(error)
				})
		},
		MarkShipmentShortage(shortageShipmentDetails) {
			this.isLoadingSearch = true;
			this.input = ({
				"processLocation": this.hubId,
				"shipmentStatus": shortageShipmentDetails.shipmentstatus,
				"status": shortageShipmentDetails.status,
				"lastModifiedBy": this.useremail,
				"shippingId": shortageShipmentDetails.shippingid,
				"isManualEntry":false,
				"shipmentCurrentHub":shortageShipmentDetails.currenthubid,
				"centerType":this.centerType
			});
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'markShipmentShortage',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.$alertify.success(result.data.ReturnMessage);
						if (result.data.nudgeMessage) { nudgeBus.$emit('show-nudge', { message: result.data.nudgeMessage, duration: result.data.nudgeDuration }) }
						this.ConfirmShipmentShortage = false;
						this.isLoadingSearch = false;
						this.getBaggedShipmentList();
						this.shortageShipmentDetails = {};
					} else {
						this.$alertify.error(result.data.ReturnMessage);
						this.ConfirmShipmentShortage = false;
						this.isLoadingSearch = false;
						this.shortageShipmentDetails = {};
					}
				}, error => {
					console.error(error)
					this.isLoadingSearch = false;
				})
		},
		resetForm() {
			this.bagno = ''
			this.SecurityPouch = ''
			this.listBagSearchdata = []
			this.BagOutShipmentlist = []
			this.showBagData = false
			this.AutoBagOut = false
			this.showshipmentList = false
			this.shipmentidwithoutsecuritypatch = ''
			this.manualInput = false
			this.checkAutoBagOutShipment = ''
			this.checkTallyBagShipment = ''
			this.BagOutShipmentlist = []
			this.$validator.reset(),
			this.dtoFlag = false;
			this.isLoading = false;
			this.shortageShipmentDetails = {};
			this.mot = '';
			this.BagOutShipmentData = [];
			this.showHideCodeIconInput();
			this.Weighingrequired=null
			this.flyerID = '';
			this.isDTOFlyer = false;
		},
		onSubmitShipment: function() {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				} else {	
					this.BagOutScanSipment();
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
		onSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},

		/*
		HUB-4094
		Prevent marking all the shipments in a bag as short
		Get list of shipments that will be mark shortage
		*/
		getBaggedShipmentList() {
			this.shippingIdList=[];
			this.isLoading=true;
			axios({
					method: 'GET',
					'url': apiUrl.api_url_hubops + 'getBaggedShipmentList?BagNo=' + this.bagno.trim(),
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
						'token': this.token
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.shippingIdList = result.data.ResponseData;
						this.modalShow=true;
					} else {
						this.$alertify.error(result.data.ReturnMessage);
					}
					this.isLoading=false;
				}, error => {
					this.isLoading=false;
					console.error(error)
				})
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/BagOutShipment/BagOutShipment.js